module.exports = __webpack_public_path__ + "img/down-arrow.385e824d.svg";